export default __webpack_public_path__ + "static/media/_login-slide-interest.0a174571.png";